<template>
  <div>
    <!-- <div>
      <b-embed
        type="iframe"
        aspect="4by3"
        src="https://www.thrustcarbon.com/products/thrust-calculator"
        allowfullscreen
      ></b-embed>
    </div> -->
    <b-card-group deck class="p-4" :style="'border: none;'">
      <b-card no-border>
        <h2><strong>Carbon Emissions CO2</strong></h2>
        <!-- <p>
        <p>
          Transport was responsible for about a quarter of the EU’s total CO2 emissions in 2019, of which 71.7% came from
          road
          transportation, according to a report from the European Environment Agency.

        </p>
        <p>
          The EU aims to achieve a 90% reduction in greenhouse gas emissions from transport by 2050, compared with 1990.
          This
          is part of its efforts to reduce CO2 emissions and achieve climate neutrality by 2050 under the European Green
          Deal
          roadmap.
        </p>       

        <p>For further information keep reading on <a
            href="https://www.eea.europa.eu/data-and-maps/data/data-viewers/greenhouse-gases-viewer" target="_blank"
           > www.eea.europa.eu</a>. </p>
        </p> -->
        <p> Total domestic emissions fell by 42.4 MtCO2e in 2020. This is the largest proportional fall in UK greenhouse
          gas emissions in a single year since the start of the data series in 1990.</p>
        <p>Over half (55%) of the decrease in total domestic greenhouse gas emissions between 2019 and 2020 was from the
          reduction in emissions from transport. This fall was the largest on record, likely as a result of the COVID-19
          restrictions. Prior to this, transport emissions stayed relatively static as improved fuel efficiency of most
          vehicles was offset by increased usage.</p>
        <p>Of the 23.5 MtCO2e reduction in emissions from transport between 2019 and 2020, 17 MtCO2e (70%) of this came
          from reduced emissions from cars. This represents 40% of the reduction in total domestic emissions for the year.
        </p>
        <p>This 2020 reporting period coincides with coronavirus restrictions, which will have impacted transport usage.
          This should be taken into consideration when making comparisons from this data.</p>
        <p>For further information keep reading on <a
            href="https://www.gov.uk/government/statistics/transport-and-environment-statistics-2022/transport-and-environment-statistics-2022"
            target="_blank"> www.gov.uk</a>. </p>
        <b-link class="pb-2" target="_blank"
          href="https://www.gov.uk/government/statistical-data-sets/energy-and-environment-data-tables-env#greenhouse-gas-emissions-env02">

          <b-img class="my-auto"
            src="https://assets.publishing.service.gov.uk/media/634d6aa1e90e0731ada4d0b3/07-image-7.svg" fluid
            alt="Greenhous Gas Emissions 2020"></b-img>
          <h6 class="text-gray text-center">Greenhouse gas emissions by transport mode, 1990 and 2020 (ENV0201)
          </h6>
        </b-link>


        <!-- href="https://www.thrustcarbon.com/products/thrust-calculator" -->
      </b-card>
      <b-card>
        <b-link class="pb-2" target="_blank"
          href="https://www.gov.uk/government/collections/uk-territorial-greenhouse-gas-emissions-national-statistics">
          <h6 class="text-gray text-center">Greenhouse gas emissions by sector, 2020, by proportion (BEIS, 2022)
          </h6>
          <b-img class="my-auto"
            src="https://assets.publishing.service.gov.uk/media/634d6aa18fa8f5346177c3a8/06-image-6.svg" fluid
            alt="Greenhous Gas Emissions 2020"></b-img>
        </b-link>



      </b-card>
    </b-card-group>
</div></template>

<script>
export default {};
</script>

<style></style>